import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { StyledTableCell } from '../table/StyledTableCell';
import { useMilestoneTableSize } from '../table/MilestoneTableSizeContext';
import { RowHoverContainer } from './styledComponents/RowHoverContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddMilestoneRow = ({
  onAddMilestone,
  readOnly
}) => {
  const size = useMilestoneTableSize();
  const innerContent = /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "400",
    children: [/*#__PURE__*/_jsx(Checkbox, {
      checked: false,
      disabled: true,
      size: "sm",
      marginBlockStart: "100"
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(AddIcon, {
        color: "icon-core-disabled",
        size: "100"
      }), /*#__PURE__*/_jsx(Text, {
        use: "disabled",
        typography: "body-100",
        truncate: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealPlan.milestones.addMilestone"
        })
      })]
    })]
  });
  const content = readOnly ? /*#__PURE__*/_jsx(Tooltip, {
    title: I18n.text('dealPlan.milestones.readOnly.addTooltip'),
    children: /*#__PURE__*/_jsx("span", {
      children: innerContent
    })
  }) : innerContent;
  const rowStyle = readOnly ? {
    cursor: 'default'
  } : undefined;
  if (size === 'small') {
    return /*#__PURE__*/_jsx(RowHoverContainer, {
      "data-test-id": "add-milestone-row",
      onClick: readOnly ? undefined : onAddMilestone,
      style: rowStyle,
      children: /*#__PURE__*/_jsx(StyledTableCell, {
        colSpan: 3,
        children: content
      })
    });
  }
  return /*#__PURE__*/_jsxs(RowHoverContainer, {
    "data-test-id": "add-milestone-row",
    onClick: readOnly ? undefined : onAddMilestone,
    style: rowStyle,
    children: [/*#__PURE__*/_jsx(StyledTableCell, {
      children: content
    }), /*#__PURE__*/_jsx(StyledTableCell, {}), /*#__PURE__*/_jsx(StyledTableCell, {}), /*#__PURE__*/_jsx(StyledTableCell, {})]
  });
};